import { render } from "./DebitorInfo.vue?vue&type=template&id=d276a00c&ts=true"
import script from "./DebitorInfo.vue?vue&type=script&lang=ts"
export * from "./DebitorInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__